<template>
  <div class="page">
    <MyTitle type="1" title="生产计划" class="title-scale"/>
    <div class="part2 flex">
      <div class="flex flex-direction justify-content justify-content-evenly">
        <div
          class="page-2 flex align-items"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="ml-20">
            <img class="img" src="@/assets/images/digitalfactory/pack.png" alt="" />
          </div>
          <div class="flex flex-direction ml-40">
            <div class="label">{{ item.label }}</div>
            <!-- <div class="number">{{ item.number }}</div> -->
            <animate-number
              class="number"
              from="0"
              :to="Number(item.number)"
              :key="Number(item.number)"
              duration="3000"
            ></animate-number>
          </div>
        </div>
      </div>
      <div class="page-3 flex flex-direction align-items">
        <div class="finishImg">
          <!-- <div class="num">{{num.toFixed(0)}}%</div> -->
          <div class="num">
            <animate-number
              class=""
              from="0"
              :to="num"
              :key="num"
              duration="3000"
            ></animate-number>
            <span class="">%</span>
          </div>
        </div>
        <div style="font-size: 48px" class="mt-20">日完成率</div>
      </div>
    </div>
  </div>
</template>

<script>
import MyTitle from '@/views/exposition/components/title2'
export default {
  components: {
    MyTitle,
  },
  data() {
    return {
      list: [
        {
          label: "PACK日目标产量",
          number: 320,
        },
        {
          label: "PACK日完成产量",
          number: 0,
        },
      ],
      num: 0,
    };
  },
  mounted() {
    let { hours } = this.getTimeFromMidnight();
    this.list[1].number = hours * this.generateRandomNumber(14, 15) ;
    this.num = (this.list[1].number / 320) * 100;
  },
  methods: {
    generateRandomNumber(min, max) {
      var randomNumber = Math.random() * (max - min) + min;
      return Math.floor(randomNumber);
    },
    getTimeFromMidnight() {
      var now = new Date(); // 获取当前时间
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // 获取当天0点时间
      var diff = now - midnight; // 计算时间差（单位为毫秒）
      var hours = Math.floor(diff / (1000 * 60 * 60)); // 将时间差转换为小时
      var minutes = Math.floor((diff / (1000 * 60)) % 60); // 将时间差转换为分钟
      var seconds = Math.floor((diff / 1000) % 60); // 将时间差转换为秒钟

      return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./page.scss";
@import "@/assets/scss/comm.scss";

.part2 {
  width: 100%;
  height: 80%;
  .page-2 {
    width: 487px;
    height: 123px;
    .img{
      width: 160px;
      height: 140px;
      animation: breath_light 3s ease infinite;
    }
    .label {
      font-size: 34px;
    }
    .number {
      font-size: 70px;
      @include ffamily-DS;
    }
  }
  .page-3 {
    width: 100%;
    height: 100%;
    .finishImg {
      position: relative;
      width: 340px;
      height: 306px;
      background: url("~@/assets/images/digitalfactory/finish.png") no-repeat;
      .num {
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: $FontSize76;
        @include ffamily-HT;
      }
    }
  }
}
</style>